import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { lightColorTokens } from '../../foundation/theme/colors/themes/light.js';
import { fontSize } from '../../../theme/typography/fontSize.js';
import { fontWeight } from '../../../theme/typography/fontWeight.js';

var primaryStyles = css(["color:", ";background-color:", ";"], themeGet('colors.gray.0'), themeGet('colors.brandPrimary.1000'));
var secondaryStyles = css(["color:", ";background-color:", ";"], themeGet('colors.text.200'), themeGet('colors.brandPrimary.50'));
var infoStyles = css(["color:", ";background-color:", ";"], themeGet('colors.gray.0'), themeGet('colors.blue.500'));
var successStyles = css(["color:", ";background-color:", ";"], themeGet('colors.gray.0'), themeGet('colors.green.500'));
var dangerStyles = css(["color:", ";background-color:", ";"], themeGet('colors.gray.0'), themeGet('colors.red.500'));
var warningStyles = css(["color:", ";background-color:", ";"], lightColorTokens.gray[1000], themeGet('colors.yellow.500'));
var stylesFromAppearance = function stylesFromAppearance(props) {
  switch (props.$appearance) {
    case 'primary':
      return primaryStyles;
    case 'info':
      return infoStyles;
    case 'success':
      return successStyles;
    case 'danger':
      return dangerStyles;
    case 'warning':
      return warningStyles;
    case 'secondary':
    default:
      return secondaryStyles;
  }
};
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1oxkv7d-0"
})(["", ";", ";padding:", " ", ";border-radius:", ";text-align:center;a{color:currentColor;font-style:normal;", ";&:hover{text-decoration:none;}}"], stylesFromAppearance, fontSize('small'), themeGet('spacing.md'), themeGet('spacing.2xl'), themeGet('borderRadius.md'), fontWeight('normal'));

export { Container };
